import React, { useState, useEffect } from "react";
import get from "lodash/get";
import Label from "components/Form/Label";
import NextButton from "../NextButton";
import PreviousButton from "../PreviousButton";
import Dropdown from "../../../components/Dropdown/Dropdown";
import ProgressBar from "../ProgressBar";
import { aboutUsOptions, booleanOptions } from "consts/general";

const Step = ({
  onChange,
  formData,
  prevStep,
  nextStep,
  onUserSignUpByStep,
  currentStep,
  totalSteps,
}) => {
  const [hasError, setHasError] = useState(false);
  const [errorMessage, setErrorMessage] = useState({});

  const onFormValidation = (_data) => {
    let result = {};
    let hasInvalidInput = false;
    const hasAffiliate = get(formData, "used_affiliate_before", "");
    const heardAboutUs = get(formData, "rewards_hear_about_us_id", "");

    if (hasAffiliate === null) {
      hasInvalidInput = true;
      result.used_affiliate_before = "This field is required.";
    }

    if (!heardAboutUs) {
      hasInvalidInput = true;
      result.rewards_hear_about_us_id = "This field is required.";
    }

    setHasError(hasInvalidInput);
    setErrorMessage(result);
    return hasInvalidInput;
  };

  useEffect(() => {
    if (hasError) onFormValidation(formData);
  }, [hasError, formData]);
  return (
    <div className="mx-auto w-full lg:w-[480px]">
      <div>
        <h1 className="my-4 text-2xl md:text-3xl font-bold tracking-tight text-primary-700">
          Affiliate & Referral 🗣️
        </h1>
        <p className="mt-2 text-sm text-primary-700">
          Affiliate and referral verbiage.
        </p>
      </div>
      <div className="mt-8">
        <ProgressBar currentStep={currentStep} totalSteps={totalSteps} />
        <form action="#" method="POST" className="space-y-6">
          <div>
            <Label>Are you currently using affiliate links?</Label>
            <Dropdown
              placeholder="Please select"
              options={booleanOptions}
              value={
                formData.used_affiliate_before !== null &&
                booleanOptions.find(
                  (option) =>
                    (option.value === "yes" &&
                      formData?.used_affiliate_before) ||
                    (option.value === "no" && !formData?.used_affiliate_before)
                )
              }
              onChange={(selected) => {
                onChange({
                  ...formData,
                  used_affiliate_before:
                    selected.value === "yes" ? true : false,
                });
              }}
              error={
                hasError ? get(errorMessage, "used_affiliate_before", "") : null
              }
              required
            />
          </div>
          <div>
            <Label>How did you hear about us?</Label>
            <Dropdown
              placeholder="Please select"
              options={aboutUsOptions}
              value={aboutUsOptions.find(
                (option) => option.value === formData?.rewards_hear_about_us_id
              )}
              onChange={(selected) =>
                onChange({
                  ...formData,
                  rewards_hear_about_us_id: selected.value,
                })
              }
              error={
                hasError
                  ? get(errorMessage, "rewards_hear_about_us_id", "")
                  : null
              }
              required
            />
          </div>
          <div className="w-full flex justify-between">
            <PreviousButton onClick={prevStep} />
            <NextButton
              onClick={() => {
                if (!onFormValidation(formData)) {
                  onUserSignUpByStep(nextStep);
                }
              }}
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default Step;
